const convertToValidNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const converted = Number(value);
    return Number.isNaN(converted) ? undefined : converted;
  }
  return undefined;
};

export default convertToValidNumber;
